import VariablesImport from './VariablesImport';

export default VariablesImport;
